export default "__VITE_ASSET__DOAdnUaF__"